import {
  Component,
  HostListener,
  Input,
  Renderer2,
  ViewChild,
} from '@angular/core';

@Component({
  selector: 'app-tooltip',
  templateUrl: './tooltip.component.html',
  styleUrls: ['./tooltip.component.scss'],
})
export class TooltipComponent {
  @Input() public tooltip: string = 'aaa';
  @ViewChild('tooltipTag', { static: false }) public tooltipTag: any;
  constructor(private renderer: Renderer2) {}

  @HostListener('click', ['$event.target'])
  onClick() {
    const tooltipTag =
      this.tooltipTag.nativeElement.getElementsByClassName('tooltip');
    if (tooltipTag.length) {
      tooltipTag[0].remove();
    } else {
      const div: HTMLParagraphElement = this.renderer.createElement('div');
      div.innerHTML = this.tooltip;
      div.className = 'tooltip';
      this.tooltipTag.nativeElement.appendChild(div);
    }
  }
}
